// extracted by mini-css-extract-plugin
export default {"container":"As-z","ratingLayout":"Bs-z","ratingLabel":"Cs-z","nonInteractiveRatingLabel":"Ds-z"};